const ELEVATION_0 = "none";
const ELEVATION_1 = "0px 2px 2px -1px rgba(0, 0, 0, 0.04), 0px 1px 3px rgba(0, 0, 0, 0.08)";
const ELEVATION_2 = "0px 1px 3px rgba(0, 0, 0, 0.05), 0px 2px 6px rgba(0, 0, 0, 0.07)";
const ELEVATION_3 = "0px 1px 3px rgba(0, 0, 0, 0.05), 0px 2px 6px rgba(0, 0, 0, 0.07)";
const ELEVATION_4 = "0px 3px 5px -1px rgba(0, 0, 0, 0.06), 0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.08)";
const ELEVATION_5 = "0px 5px 5px -3px rgba(0, 0, 0, 0.03), 0px 8px 10px 1px rgba(0, 0, 0, 0.08), 0px 3px 14px 2px rgba(0, 0, 0, 0.06)";
const ELEVATION_6 = "0px 10px 13px -6px rgba(0, 0, 0, 0.11), 0px 20px 31px 3px rgba(0, 0, 0, 0.06), 0px 8px 38px 7px rgba(0, 0, 0, 0.08)";
const ELEVATION_7_TO_24 = "none";
export const shadows = [
    ELEVATION_0,
    ELEVATION_1,
    ELEVATION_2,
    ELEVATION_3,
    ELEVATION_4,
    ELEVATION_5,
    ELEVATION_6,
    ...Array(18).fill(ELEVATION_7_TO_24),
];
//# sourceMappingURL=shadows.js.map